(function GroupRegistrationExport($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GroupRegistrationExport',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}
		location.href = response.data;
	};

}(jQuery, window.Adzuki || {}));